import { useState } from "react";
import { useTranslation } from "react-i18next";

import CorporationDialog from "../dialogTypes/CorporationDialog";
import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";

function CorporationManageUpdateButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onClose, onSuccess, createButtonName, customizeErrorMsgCallback, setInitialDataCallback, modifyUrlCallback ,...others } = props;
    const [ open, setOpen ] = useState(false);
    const [formData, setFormData] = useState();
    
    const onOpen = () => {

        if (grid) {
            setFormData({ ...grid.selectedItems[0] });
        }

        setOpen(true);
    };

    const onDialogClose = () => {

        setOpen ( false );

        if ( onClose ) {

            onClose ();

        }

    };

    const onUpdateSuccess = (msg) => {
        if ( onSuccess ) {

            onSuccess ( msg );

        }

        if(refresh) {
            refresh.refresh ();
        }

    };

    return (

        <>
            <UpdateRecordButtonLayout id={id+"update-button"} onClick={onOpen} {...others} />
            <CorporationDialog
                id={id+"update-dialog"}
                mode="edit"
                method = "put"
                formId={id+"update-form"}
                initialData={formData}
                title={ schema ? t ( `dialog.title.${id}.update` ) : "" }
                schema={schema}
                open={open}
                onClose={onDialogClose}
                onSuccess={onUpdateSuccess}
            />
        </>

    );
}

export default CorporationManageUpdateButton;

